import { Helmet } from "react-helmet-async";

type SEOProps = {
  title?: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
  image?: string;
  jsonLd?: object | object[];
};

const DEFAULT_TITLE =
  "LRScribe — HIPAA-Compliant AI Medical Transcription & SOAP Note Generator";
const DEFAULT_DESCRIPTION =
  "LRScribe is a HIPAA-compliant AI medical scribe that turns patient visit recordings into accurate transcripts and SOAP notes in seconds.";
const DEFAULT_IMAGE = "https://lrscribe.com/og-image.jpg";

export function SEO({
  title,
  description,
  canonical,
  noindex,
  image,
  jsonLd,
}: SEOProps) {
  const finalTitle = title ?? DEFAULT_TITLE;
  const finalDescription = description ?? DEFAULT_DESCRIPTION;
  const finalImage = image ?? DEFAULT_IMAGE;
  const jsonLdArray = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      {jsonLdArray.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
